export enum ViewModes {
    SearchForLegalRepresent,
    SearchForPotentialAttendat,
    SearchShareholderForLegalRepresenter,
    SearchForNotShareholder,
}
